import request, { Methods } from "../../../../assets/util/request";

//* ACTIONTYPES --------------------------------------------
export const GET_ALL_ROUTE_BY_TOKEN_LOADING = 'GET_ALL_ROUTE_BY_TOKEN_LOADING';
export const GET_ALL_ROUTE_BY_TOKEN_SUCCESS = 'GET_ALL_ROUTE_BY_TOKEN_SUCCESS';
export const GET_ALL_ROUTE_BY_TOKEN_REJECT = 'GET_ALL_ROUTE_BY_TOKEN_REJECT';

//* ACTIONS ------------------------------------------------
export const getAllRouteByTokenLoading = () => ({ type: GET_ALL_ROUTE_BY_TOKEN_LOADING });
export const getAllRouteByTokenSuccess = (payload) => ({ type: GET_ALL_ROUTE_BY_TOKEN_SUCCESS, payload });
export const getAllRouteByTokenReject = (payload) => ({ type: GET_ALL_ROUTE_BY_TOKEN_REJECT, payload });

//* REQUEST SERVICE ---------------------------------------
export const getAllRouteByTokenRequest = async (token) => {
    const options = { method: Methods.GET };
    return request(`/Route/web/GetAllOnRoutesByToken/${token}`, options);
};
